(function () {
  function initInstagramSliders() {
    var sliders = document.querySelectorAll('[data-ig-slider]');
    if (!sliders.length) return;

    sliders.forEach(function (slider) {
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      var container = slider.closest('.ig-slider__container');
      if (!container) return;

      var track = slider.querySelector('.ig-slider__slides');
      if (!track) return;

      var prevBtn = container.querySelector('.ig-slider__prev');
      var nextBtn = container.querySelector('.ig-slider__next');
      var currentIndex = 0;

      function getSlidesPerView() {
        var w = window.innerWidth;
        var desktop = parseInt(container.dataset.slidesDesktop || '4', 10);
        var tablet = parseInt(container.dataset.slidesTablet || '3', 10);
        var mobile = parseInt(container.dataset.slidesMobile || '2', 10);
        if (w >= 990) return desktop;
        if (w >= 768) return tablet;
        return mobile;
      }

      function getMaxIndex() {
        var total = track.children.length;
        var perView = getSlidesPerView();
        return Math.max(0, total - perView);
      }

      function updateSlider() {
        var perView = getSlidesPerView();
        var maxIndex = getMaxIndex();
        if (currentIndex > maxIndex) currentIndex = maxIndex;

        var slideWidth = track.children.length > 0
          ? track.children[0].getBoundingClientRect().width
          : 0;

        var gap = 16;
        var offset = currentIndex * (slideWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';

        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          currentIndex = Math.max(0, currentIndex - 1);
          updateSlider();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          currentIndex = Math.min(getMaxIndex(), currentIndex + 1);
          updateSlider();
        });
      }

      var startX = 0;
      var isDragging = false;

      function handleTouchStart(e) {
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        isDragging = true;
      }

      function handleTouchEnd(e) {
        if (!isDragging) return;
        isDragging = false;
        var endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        var diff = startX - endX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            currentIndex = Math.min(getMaxIndex(), currentIndex + 1);
          } else {
            currentIndex = Math.max(0, currentIndex - 1);
          }
          updateSlider();
        }
      }

      slider.addEventListener('touchstart', handleTouchStart, { passive: true });
      slider.addEventListener('touchend', handleTouchEnd, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateSlider, 150);
      });

      updateSlider();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstagramSliders);
  } else {
    initInstagramSliders();
  }

  document.addEventListener('shopify:section:load', initInstagramSliders);
  document.addEventListener('shopify:block:select', initInstagramSliders);
})();
